//document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
//$(".clearCart").css("border","1px solid red");
//$(".clearCart").click();

//});


const radioButtons = document.querySelectorAll('input[name="sub-option"]');
function updateActiveOption(selectedRadio) {
    radioButtons.forEach(radio => {
        radio.classList.remove('active-option');
    });
    selectedRadio.classList.add('active-option');
}

radioButtons.forEach(radio => {
    radio.addEventListener('change', () => {
        updateActiveOption(radio);
    });
});


$(window).on("pageshow", function() {
  $('.js-qty__num').val('1');
  if (!$(".add-multiples").hasClass('add-multiples__best-sellers') && !$(".add-multiples").hasClass('add-multiples__variety') && !$(".add-multiples").hasClass('add-multiples__chocolate') && !$(".add-multiples").hasClass('add-multiples__love')) {
    $(".add-multiples").attr("href", function (i, href) {
      var index = href.indexOf("&properties[Bundle Subtotal]");
      return (index == -1 ? href : href.substring(0, index)) + "&properties[Bundle Subtotal]=" + $('.original-price').text();
    });
  };
});

$(document).ready(function () {
  $('.product__media-list-custom').slick({
    arrows: false,
    centerMode: true,
    centerPadding: '20%',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true
  });

  $('.left-slick-arrow').click(function () {
    $('.product__media-list-custom').slick('slickPrev');
  });

  $('.right-slick-arrow').click(function () {
    $('.product__media-list-custom').slick('slickNext');
  });



  var originalPrice = $('.original-price').text().replace("$", "");
  let originalPriceAsInt = parseInt(originalPrice, 10);
  var subscriptionPrice = originalPriceAsInt * 0.8509;
  var subscriptionPriceFormatted = subscriptionPrice.toFixed(2);

  $('#subscribe-label').click(function (event) {
    if (!$(event.target).closest('.skio-frequency-ctr').length) {
      $('.js-qty__num').val('1');
      $('.product-unit-count__units').text('16');
      $(".add-multiples").attr("href", function (i, href) {
        var index = href.indexOf("&selling_plan");
        return (index == -1 ? href : href.substring(0, index)) + "&selling_plan=" + $(".skio-frequency option:selected").val();
      });
      $(".product__price").text("$" + subscriptionPriceFormatted);
      $(".original-price").css("display", "inline");
      $(".skio-frequency-ctr").addClass('selling-plans-active');
    };
  });

  $('#one-time-label').click(function () {
    $('.js-qty__num').val('1');
    $('.product-unit-count__units').text('16');
    $(".add-multiples").attr("href", function (i, href) {
      var index = href.indexOf("&selling_plan");
      return (index == -1 ? href : href.substring(0, index)) + "&selling_plan=";
    });
    $(".product__price").text("$" + originalPrice);
    $(".original-price").css("display", "none");
    $(".skio-frequency-ctr").removeClass('selling-plans-active');
  });

  
  $(".skio-frequency").on('change', function() {
    if ($("#subscribe").hasClass('active-option')) {
      $(".add-multiples").attr("href", function (i, href) {
          var index = href.indexOf("&selling_plan");
          return (index == -1 ? href : href.substring(0, index)) + "&selling_plan=" + $(".skio-frequency option:selected").val();
      });
    }
  });


});


$(document).ready(function () {
  $('.video-section_slider').slick({
    arrows: false,
    cslidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    slidesToScroll: 1,
    infinite: false,
    responsive: [{
      breakpoint: 890,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true
      }
    }]
  });

  $('.left-slick-arrow_video').click(function () {
    $('.video-section_slider').slick('slickPrev');
  })

  $('.right-slick-arrow_video').click(function () {
    $('.video-section_slider').slick('slickNext');
  })

  $('.left-slick-arrow_video, .custom-next').addClass('disabled');

  $('.video-section_slider').on('init', function () {
    $('.left-slick-arrow_video, .right-slick-arrow_video').removeClass('disabled');
  });

  $('.video-section_slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    if (nextSlide === 0) {
      $('.left-slick-arrow_video').addClass('disabled');
    } else if (nextSlide === slick.slideCount - 1) {
      $('.right-slick-arrow_video').addClass('disabled');
    } else {
      $('.left-slick-arrow_video, .right-slick-arrow_video').removeClass('disabled');
    }
  });

});

// Accordions section
const initAccordions = () => {
  const accordionItems = document.querySelectorAll('.accordion__item');
  accordionItems.forEach(item => {
    const iconPlus = item.querySelector('.accordion__icon-plus');
    const iconMinus = item.querySelector('.accordion__icon-minus');
    item.addEventListener('click', () => {
      item.classList.toggle("active");
      iconPlus.classList.toggle('expanded');
      iconMinus.classList.toggle('expanded');
    });
  });
}
initAccordions();
document.addEventListener("shopify:section:load", function (event) {
  initAccordions();
});

//Ingredients popup
const ingredientsPopup = () => {
  const popUpBtn = document.querySelector('.btn--popup-ingredients');
  const ingredientsPopup = document.querySelector('.ingredients-popup');
  const overlay = document.querySelector('.ingredients-background-overlay');
  const closeBtn = document.querySelector('.ingredients-popup .icon-close');

  popUpBtn.addEventListener('click', function () {
    ingredientsPopup.classList.add('is-expanded');
    overlay.classList.add('is-expanded');
    document.body.classList.add('no-scroll-lock');
    document.documentElement.classList.add('no-scroll-lock');
  });

  closeBtn.addEventListener('click', function () {
    ingredientsPopup.classList.remove('is-expanded');
    overlay.classList.remove('is-expanded');
    document.body.classList.remove('no-scroll-lock');
    document.documentElement.classList.remove('no-scroll-lock');
  });

  overlay.addEventListener('click', function () {
    ingredientsPopup.classList.remove('is-expanded');
    overlay.classList.remove('is-expanded');
    document.body.classList.remove('no-scroll-lock');
    document.documentElement.classList.remove('no-scroll-lock');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      ingredientsPopup.classList.remove('is-expanded');
      overlay.classList.remove('is-expanded');
      document.body.classList.remove('no-scroll-lock');
      document.documentElement.classList.remove('no-scroll-lock');
    }
  });
};
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector('.section--ingredients-showcase')) {
    ingredientsPopup();
  }
});

const prodForm = () => {
  const quantitySelector = document.querySelector('.js-qty__num');
  const priceElement = document.getElementById('product-price');
  const skioForm = document.querySelector('skio-plan-picker');
  const orginalPrice = document.querySelector('.original-price');
  const originalProdUnits = document.querySelector('.product-unit-count');
  const prodUnitsHolder = document.querySelector('.product-unit-count__units');

  if (!skioForm) {
    console.error('skioForm element not found');
    return;
  }

  let basePrice = parseFloat(priceElement.getAttribute('data-price')) / 100;
  let baseOriginalPrice = parseFloat(priceElement.getAttribute('data-price')) / 100;
  let baseUnits = parseFloat(originalProdUnits.getAttribute('data-product-unit-count'));
  let cartQuantity = 4;

  $('#subscribe-label').click(function () {
    updatePrice();
  });

  $('#one-time-label').click(function () {
    updatePrice();
  });

  function updatePrice() {
    const quantity = parseInt(quantitySelector.value);
    const subscribeOption = document.querySelector('#subscribe');
    let finalPrice = basePrice * quantity;
    let finalOriginalPrice = baseOriginalPrice * quantity;
    let finalUnits = baseUnits * quantity;
    let cartQuantity = quantity * 4;
    let variantID = document.getElementById('variant').value;


    if (quantity >= 3 && subscribeOption.checked) {
      finalPrice *= 0.76581;
      orginalPrice.style.display = "inline";
    } else if (quantity >= 2 && subscribeOption.checked) {
      finalPrice *= 0.80827;
      orginalPrice.style.display = "inline";
    } else if (subscribeOption.checked) {
      finalPrice *= 0.8509;
      orginalPrice.style.display = "inline";
    } else if (quantity >= 3 && !subscribeOption.checked) {
      finalPrice *= 0.90;
      orginalPrice.style.display = "inline";
    } else if (quantity >= 2 && !subscribeOption.checked) {
      finalPrice *= 0.95;
      orginalPrice.style.display = "inline";
    } else {
      orginalPrice.style.display = "none";
    }


    const newPrice = finalPrice.toFixed(2);
    const newOriginalPrice = finalOriginalPrice.toFixed(2);
    const newUnits = finalUnits;

    priceElement.textContent = `$${newPrice}`;
    orginalPrice.textContent = `$${newOriginalPrice}`;
    prodUnitsHolder.textContent = `${newUnits}`;

    // update line item properties
    $("#number-of-bars").attr("value", newUnits);
    $("#bundle-subtotal").attr("value", finalPrice);

    if ($(".add-multiples").hasClass('add-multiples__best-sellers')) {

      // /cart/add?id[]=47901584294169&quantity[]=1&id[]=44409821004057&quantity[]=1&id[]=44409441255705&quantity[]=1&id[]=45702858506521&quantity[]=1&properties[Bars per box]=4"
      let prodsHolder = "id[]=47901584294169&quantity[]=1&id[]=44409821004057&quantity[]=1&id[]=44409441255705&quantity[]=1&id[]=45703214694681&quantity[]=1&";

      let repeatedProdsHolder = prodsHolder.repeat(quantity);

      $(".add-multiples").attr("href", "/cart/add?" + repeatedProdsHolder + "properties[Bars per box]=4");

      if ($("#subscribe").is(':checked')) {
        $(".add-multiples").attr("href", "/cart/add?" + repeatedProdsHolder + "properties[Bars per box]=4" + "&selling_plan=" + $(".skio-frequency option:selected").val());
      }
      if ($("#one-time").is(':checked')) {
        $(".add-multiples").attr("href", );
      }
      // $('#subscribe-label').click(function () {
      //   $(".add-multiples").attr("href", "/cart/add?" + repeatedProdsHolder + "properties[Bars per box]=4" + "&selling_plan=" + $(".skio-frequency option:selected").val());
      // });
      // $('#one-time-label').click(function () {
      //   $(".add-multiples").attr("href", "/cart/add?" + repeatedProdsHolder + "properties[Bars per box]=4" );
      // });


    } else if ($(".add-multiples").hasClass('add-multiples__variety')) {

      // /cart/add?id[]=47901584294169&quantity[]=1&id[]=45703214694681&quantity[]=&id[]=45702858506521&quantity[]=1&id[]=47901584294169&quantity[]=1&properties[Bars per box]=4

      let prodsHolder = "id[]=47901584294169&quantity[]=1&id[]=50257807409433&quantity[]=&id[]=45702858506521&quantity[]=1&id[]=50257807409433&quantity[]=1&properties[Bars per box]=4&";

      let repeatedProdsHolder = prodsHolder.repeat(quantity);

      $(".add-multiples").attr("href", "/cart/add?" + repeatedProdsHolder + "properties[Bars per box]=4");

      if ($("#subscribe").is(':checked')) {
        $(".add-multiples").attr("href", "/cart/add?" + repeatedProdsHolder + "properties[Bars per box]=4" + "&selling_plan=" + $(".skio-frequency option:selected").val());
      }
      if ($("#one-time").is(':checked')) {
        $(".add-multiples").attr("href", );
      }
      // $('#subscribe-label').click(function () {
      //   $(".add-multiples").attr("href", "/cart/add?" + repeatedProdsHolder + "properties[Bars per box]=4" + "&selling_plan=" + $(".skio-frequency option:selected").val());
      // });
      // $('#one-time-label').click(function () {
      //   $(".add-multiples").attr("href", "/cart/add?" + repeatedProdsHolder + "properties[Bars per box]=4" );
      // });

      
    } else if ($(".add-multiples").hasClass('add-multiples__love')) {

      // /cart/add?id[]=47901584294169&quantity[]=1&id[]=45703214694681&quantity[]=&id[]=45702858506521&quantity[]=1&id[]=47901584294169&quantity[]=1&properties[Bars per box]=4

      let prodsHolder = "id[]=44409821004057&quantity[]=1&id[]=44409845023001&quantity[]=&id[]=45702858506521&quantity[]=1&id[]=45703214694681&quantity[]=1&properties[Bars per box]=4&";

      let repeatedProdsHolder = prodsHolder.repeat(quantity);

      $(".add-multiples").attr("href", "/cart/add?" + repeatedProdsHolder + "properties[Bars per box]=4");

      if ($("#subscribe").is(':checked')) {
        $(".add-multiples").attr("href", "/cart/add?" + repeatedProdsHolder + "properties[Bars per box]=4" + "&selling_plan=" + $(".skio-frequency option:selected").val());
      }
      if ($("#one-time").is(':checked')) {
        $(".add-multiples").attr("href", );
      }
      // $('#subscribe-label').click(function () {
      //   $(".add-multiples").attr("href", "/cart/add?" + repeatedProdsHolder + "properties[Bars per box]=4" + "&selling_plan=" + $(".skio-frequency option:selected").val());
      // });
      // $('#one-time-label').click(function () {
      //   $(".add-multiples").attr("href", "/cart/add?" + repeatedProdsHolder + "properties[Bars per box]=4" );
      // });

      
    } else if ($(".add-multiples").hasClass('add-multiples__chocolate')) {

      // /cart/add?id[]=47901584294169&quantity[]=1&id[]=45703214694681&quantity[]=&id[]=45702858506521&quantity[]=1&id[]=47901584294169&quantity[]=1&properties[Bars per box]=4

      let prodsHolder = "id[]=44409821004057&quantity[]=1&id[]=44409821004057&quantity[]=&id[]=44409845023001&quantity[]=1&id[]=44409845023001&quantity[]=1&properties[Bars per box]=4&";

      let repeatedProdsHolder = prodsHolder.repeat(quantity);

      $(".add-multiples").attr("href", "/cart/add?" + repeatedProdsHolder + "properties[Bars per box]=4");

      if ($("#subscribe").is(':checked')) {
        $(".add-multiples").attr("href", "/cart/add?" + repeatedProdsHolder + "properties[Bars per box]=4" + "&selling_plan=" + $(".skio-frequency option:selected").val());
      }
      if ($("#one-time").is(':checked')) {
        $(".add-multiples").attr("href", );
      }
      // $('#subscribe-label').click(function () {
      //   $(".add-multiples").attr("href", "/cart/add?" + repeatedProdsHolder + "properties[Bars per box]=4" + "&selling_plan=" + $(".skio-frequency option:selected").val());
      // });
      // $('#one-time-label').click(function () {
      //   $(".add-multiples").attr("href", "/cart/add?" + repeatedProdsHolder + "properties[Bars per box]=4" );
      // });
    }
    
    else {
      
      $(".add-multiples").attr("href", "/cart/add?id=" + variantID + "&quantity=" + cartQuantity + "&properties[Number of Bars]=" + finalUnits + "&properties[Bundle Subtotal]=$" + newPrice);

      if ($("#subscribe").is(':checked')) {
        $(".add-multiples").attr("href", "/cart/add?id=" + variantID + "&quantity=" + cartQuantity + "&properties[Number of Bars]=" + finalUnits + "&properties[Bundle Subtotal]=$" + newPrice + "&selling_plan=" + $(".skio-frequency option:selected").val());
      }
      if ($("#one-time").is(':checked')) {
        $(".add-multiples").attr("href", "/cart/add?id=" + variantID + "&quantity=" + cartQuantity + "&properties[Number of Bars]=" + finalUnits + "&properties[Bundle Subtotal]=$" + newPrice);
      }
      // $('#subscribe-label').click(function () {
      //   $(".add-multiples").attr("href", "/cart/add?id=" + variantID + "&quantity=" + cartQuantity + "&properties[Number of Bars]=" + finalUnits + "&properties[Bundle Subtotal]=$" + newPrice + "&selling_plan=" + $(".skio-frequency option:selected").val());
      // });
      // $('#one-time-label').click(function () {
      //   $(".add-multiples").attr("href", "/cart/add?id=" + variantID + "&quantity=" + cartQuantity + "&properties[Number of Bars]=" + finalUnits + "&properties[Bundle Subtotal]=$" + newPrice);
      // });
    }

  }

  function onQuantityChange() {
    updatePrice();
  }

  quantitySelector.addEventListener('input', onQuantityChange);

  document.querySelector('.js-qty__adjust--plus').addEventListener('click', function () {
    quantitySelector.value = parseInt(quantitySelector.value);
    onQuantityChange();
  });

  document.querySelector('.js-qty__adjust--minus').addEventListener('click', function () {
    if (parseInt(quantitySelector.value) > 1) {
      quantitySelector.value = parseInt(quantitySelector.value);
      onQuantityChange();
    } else {
      quantitySelector.value = 1;
      onQuantityChange();
    }
  });

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        updatePrice();
      }
    }
  });

  const config = {
    attributes: true
  };

  observer.observe(skioForm, config);
};
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector('.product-block__form')) {
    prodForm();
  }
});

// Smooth scroll
document.querySelector('a[href^="#"]').addEventListener('click', function (event) {
  event.preventDefault();
  const targetId = this.getAttribute('href');
  const targetElement = document.querySelector(targetId);
  window.scrollTo({
    top: targetElement.offsetTop,
    behavior: 'smooth'
  });
});